import { render, staticRenderFns } from "./TaxDataTable.vue?vue&type=template&id=91bbad84"
import script from "./TaxDataTable.vue?vue&type=script&lang=js"
export * from "./TaxDataTable.vue?vue&type=script&lang=js"
import style0 from "./TaxDataTable.vue?vue&type=style&index=0&id=91bbad84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports